import { render, staticRenderFns } from "./EmployerOtherFormulaSelect.vue?vue&type=template&id=f52adb22&"
import script from "./EmployerOtherFormulaSelect.vue?vue&type=script&lang=js&"
export * from "./EmployerOtherFormulaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports